export function addEventListenerBath<K extends keyof HTMLElementEventMap>({
  selector,
  callback,
  event,
}: {
  selector: string;
  callback: (this: Element, ev: HTMLElementEventMap[K]) => void;
  event: K;
}) {
  const buttons = document.querySelectorAll<HTMLDivElement>(selector);

  // 为每个按钮批量添加点击事件监听器
  buttons.forEach((button) => {
    button.addEventListener(event, callback);
  });
}

export function removeEventListenerBath<K extends keyof HTMLElementEventMap>({
  selector,
  callback,
  event,
}: {
  selector: string;
  callback: (this: Element, ev: HTMLElementEventMap[K]) => void;
  event: K;
}) {
  const buttons = document.querySelectorAll(selector);

  // 为每个按钮批量添加点击事件监听器
  buttons.forEach((button) => {
    button.removeEventListener(event as any, callback);
  });
}

export const addEventBatch = <K extends keyof HTMLElementEventMap>(
  selector: string,
  event: K,
  callback: (this: Element, ev: HTMLElementEventMap[K]) => void,
) => {
  const elements = document.querySelectorAll<HTMLElement>(selector);
  elements.forEach((element) => {
    element.addEventListener(event, callback);
  });
};
